export default function(store, options) {
  const RoleTag = store.defineModel('roleTag', {
    replaceKeys: {
      tagColor: 'color',
      tagName: 'name',
    },

    relations: {
      belongsTo: {
        organization: { type: 'organization', foreignKey: 'organizationId' },
      },
      hasMany: {
        roles: { type: 'role', foreignKey: 'roleTagId' },
      }
    },

    parseAttrs(attrs) {
      if ('colorValue' in attrs) {
        const colorId = attrs.color
        const color = attrs.colorValue
        attrs.color = color
        attrs.colorId = colorId
        delete attrs.colorValue
      }

      if ('color' in attrs) attrs.color = attrs.color.replace('0x', '#')

      return attrs
    },

    afterAssignment(entity) {
      const { name } = entity

      entity.displayName = name
      entity.isDefault = name && name.startsWith('Default')
    },
  })

  return RoleTag
}
